/* eslint-disable */
export const scLayersConfig = {
  "http://192.168.88.69:10262/api/ritm_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "type"]],
        "road",
        "roadAccident",
        "work",
        "roadWork",
        "events",
        "roadEvent",
        "roadEvent"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "http://192.168.88.69:10262/api/ritm_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "type"]],
        "road",
        "rgba(255, 62, 62, 0.1)",
        "work",
        "rgba(255, 169, 49, 0.1)",
        "events",
        "rgba(255, 238, 0, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "type"]],
        "road",
        "rgba(255, 62, 62, 1)",
        "work",
        "rgba(255, 169, 49, 1)",
        "events",
        "rgba(255, 238, 0, 1)",
        "rgba(255, 62, 62, 1)"
      ],
      "circle-stroke-width": 1
    }
  },
  "http://192.168.88.69:10262/api/ritm_Polygon": {
    type: "fill",
    layout: {},
    paint: {
      "fill-color": [
        "match",
        ["to-string", ["get", "type"]],
        "road",
        "rgba(255, 62, 62, 1)",
        "work",
        "rgba(255, 169, 49, 1)",
        "events",
        "rgba(255, 238, 0, 1)",
        "rgba(255, 62, 62, 1)"
      ],
      "fill-opacity": 0.4
    }
  },
  "http://192.168.88.69:10262/api/ritm_LineString": {
    type: "line",
    layout: {},
    paint: {
      "line-width": 3,
      "line-color": [
        "match",
        ["to-string", ["get", "type"]],
        "road",
        "rgba(255, 62, 62, 1)",
        "work",
        "rgba(255, 169, 49, 1)",
        "events",
        "rgba(255, 238, 0, 1)",
        "rgba(255, 62, 62, 1)"
      ]
    }
  },
  "https://lenobl.ritm3.ru/xml_server_results/?limit=10_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": "rgba(89, 214, 78, 0.1)",
      "circle-pitch-alignment": "map",
      "circle-stroke-color": "#59D64E",
      "circle-stroke-width": 1
    }
  },
  "https://lenobl.ritm3.ru/xml_server_results/?limit=10_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": "cameraWork",
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "2600d74b-3842-4311-9aa7-a2d742df36da_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "online"]],
        "true",
        "rgba(89, 214, 78, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "online"]],
        "true",
        "#59D64E",
        "#FF3E3E"
      ],
      "circle-stroke-width": 1
    }
  },
  "2600d74b-3842-4311-9aa7-a2d742df36da_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "online"]],
        "true",
        "streetLightWork",
        "streetLightError"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "875c93e3-dc09-41bc-b675-51b7461abca1_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "error_flags"]],
        "0",
        "rgba(89, 214, 78, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "error_flags"]],
        "0",
        "#59D64E",
        "#FF3E3E"
      ],
      "circle-stroke-width": 1
    }
  },
  "875c93e3-dc09-41bc-b675-51b7461abca1_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "error_flags"]],
        "0",
        "trafficLightsWork",
        "trafficLightsError"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "fe19e836-9559-4834-9f3d-722001dd3dbf_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": "rgba(89, 214, 78, 0.1)",
      "circle-pitch-alignment": "map",
      "circle-stroke-color": "#59D64E",
      "circle-stroke-width": 1
    }
  },
  "fe19e836-9559-4834-9f3d-722001dd3dbf_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": "meteostationWork",
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "f4695c7a-4a9c-41fe-84fe-88fb6fb2b2a3_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": "rgba(99, 99, 99, 0.1)",
      "circle-pitch-alignment": "map",
      "circle-stroke-color": "#999999",
      "circle-stroke-width": 1
    }
  },
  "f4695c7a-4a9c-41fe-84fe-88fb6fb2b2a3_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": "meteostation",
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "track/telemetry.track_data?format=last_tracks_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": "rgba(89, 214, 78, 0.1)",
      "circle-pitch-alignment": "map",
      "circle-stroke-color": "#59D64E",
      "circle-stroke-width": 1
    }
  },
  chsmeo_traffic_light_Point: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "mode"]],
        "нет ошибок",
        "rgba(89, 214, 78, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "mode"]],
        "нет ошибок",
        "#59D64E",
        "#FF3E3E"
      ],
      "circle-stroke-width": 1
    }
  },
  "tagil_traffic_light?format=from_service_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "mode"]],
        "нет ошибок",
        "rgba(89, 214, 78, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "mode"]],
        "нет ошибок",
        "#59D64E",
        "#FF3E3E"
      ],
      "circle-stroke-width": 1
    }
  },
  "chsmeo_meteo_data?format=from_service_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "status"]],
        "true",
        "rgba(89, 214, 78, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "status"]],
        "true",
        "#59D64E",
        "#FF3E3E"
      ],
      "circle-stroke-width": 1
    }
  },
  chsmeo_wialon_tracks_Point: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "organization"]],
        "stroimekhanizatsiya",
        "rgba(255, 62, 62, 0.1)",
        "stroytech",
        "rgba(55, 126, 184, 0.1)",
        "ural_syberian_company",
        "rgba(77, 175, 74, 0.1)",
        "stroi_servis",
        "rgba(166, 86, 40, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "organization"]],
        "stroimekhanizatsiya",
        "rgb(255, 62, 62)",
        "stroytech",
        "rgb(55, 126, 184)",
        "ural_syberian_company",
        "rgb(77, 175, 74)",
        "stroi_servis",
        "rgb(166, 86, 40)",
        "rgb(255, 62, 62)"
      ],
      "circle-stroke-width": 1
    }
  },
  chsmeo_tlt7_Point: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": "rgba(255, 113, 0, 0.1)",
      "circle-pitch-alignment": "map",
      "circle-stroke-color": "rgb(255, 113, 0)",
      "circle-stroke-width": 1
    }
  },
  chsmeo_cams_Point: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "status"]],
        "work",
        "rgba(89, 214, 78, 0.1)",
        "error",
        "rgba(255, 62, 62, 0.1)",
        "inactive",
        "rgba(119, 119, 119, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "status"]],
        "work",
        "rgb(89, 214, 78)",
        "error",
        "rgb(255, 62, 62)",
        "inactive",
        "rgb(119, 119, 119)",
        "rgb(255, 62, 62)"
      ],
      "circle-stroke-width": 1
    }
  },
  "8560fe75-49b2-432a-8494-eab530c8fc4e_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": "rgba(89, 214, 78, 0.1)",
      "circle-pitch-alignment": "map",
      "circle-stroke-color": "rgb(89, 214, 78)",
      "circle-stroke-width": 1
    }
  },
  "db258075-aaf2-43c3-85da-065834afada3_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": "rgba(89, 214, 78, 0.1)",
      "circle-pitch-alignment": "map",
      "circle-stroke-color": "rgb(89, 214, 78)",
      "circle-stroke-width": 1
    }
  },
  chsmeo_ngpt_Point: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "type"]],
        "1",
        "rgba(46, 147, 254, 0.1)",
        "2",
        "rgba(89, 214, 78, 0.1)",
        "3",
        "rgba(255, 172, 0, 0.1)",
        "4",
        "rgba(179, 62, 169, 0.1)",
        "rgba(119, 119, 119, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "type"]],
        "1",
        "rgb(46, 147, 254)",
        "2",
        "rgb(89, 214, 78)",
        "3",
        "rgb(255, 172, 0)",
        "4",
        "rgb(179, 62, 169)",
        "rgb(119, 119, 119)"
      ],
      "circle-stroke-width": 1
    }
  },
  "12ff4f13-bb98-43c8-bd34-d69808b72c5d_LineString": {
    type: "line",
    layout: {},
    paint: {
      "line-width": 3,
      "line-color": "#2E93FE"
    }
  },
  "7fc1a76e-84e7-44b7-aed0-b3df8b04b867_LineString": {
    type: "line",
    layout: {},
    paint: {
      "line-width": 3,
      "line-color": "#2E93FE"
    }
  },
  events_Point: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "event_class_id"]],
        "ДТП",
        "rgba(255, 62, 62, 0.1)",
        "Ремонтные работы",
        "rgba(255, 169, 49, 0.1)",
        "Мероприятия",
        "rgba(255, 238, 0, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "event_class_id"]],
        "ДТП",
        "rgba(255, 62, 62, 1)",
        "Ремонтные работы",
        "rgba(255, 169, 49, 1)",
        "Мероприятия",
        "rgba(255, 238, 0, 1)",
        "rgba(255, 62, 62, 1)"
      ],
      "circle-stroke-width": 1
    }
  },
  events_Polygon: {
    type: "fill",
    layout: {},
    paint: {
      "fill-color": [
        "match",
        ["to-string", ["get", "event_class_id"]],
        "ДТП",
        "rgba(255, 62, 62, 1)",
        "Ремонтные работы",
        "rgba(255, 169, 49, 1)",
        "Мероприятия",
        "rgba(255, 238, 0, 1)",
        "rgba(255, 62, 62, 1)"
      ],
      "fill-opacity": 0.4
    }
  },
  events_LineString: {
    type: "line",
    layout: {},
    paint: {
      "line-width": 3,
      "line-color": [
        "match",
        ["to-string", ["get", "event_class_id"]],
        "ДТП",
        "rgba(255, 62, 62, 1)",
        "Ремонтные работы",
        "rgba(255, 169, 49, 1)",
        "Мероприятия",
        "rgba(255, 238, 0, 1)",
        "rgba(255, 62, 62, 1)"
      ]
    }
  },

  track_layer: {
    type: "line",
    layout: {},
    paint: {
      "line-width": 3,
      "line-color": [
        "interpolate",
        ["linear"],
        ["get", "avg_speed"],
        0,
        "#d53e4f",
        10,
        "#fc8d59",
        20,
        "#fee08b",
        30,
        "#ffffbf",
        40,
        "#e6f598",
        50,
        "#99d594",
        60,
        "#3288bd"
      ]
    }
  },

  track_layer_tagil: {
    type: "line",
    layout: {},
    paint: {
      "line-width": 3,
      "line-color": "#3288bd"
    }
  },

  "track/telemetry.track_data?format=last_tracks_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": "car",
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  chsmeo_traffic_light_Point_s: {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "mode"]],
        "нет ошибок",
        "trafficLightsWork",
        "trafficLightsError"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "tagil_traffic_light?format=from_service_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "mode"]],
        "нет ошибок",
        "trafficLightsWork",
        "trafficLightsError"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "chsmeo_meteo_data?format=from_service_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "status"]],
        "true",
        "meteostationWork",
        "meteostationError"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  chsmeo_wialon_tracks_Point_s: {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "organization"]],
        "stroimekhanizatsiya",
        "bulldozerRed",
        "stroytech",
        "bulldozerBlue",
        "ural_syberian_company",
        "bulldozerGreen",
        "stroi_servis",
        "bulldozerBrown",
        "bulldozer"
      ],
      "icon-size": {
        base: 2,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  chsmeo_tlt7_Point_s: {
    type: "symbol",
    layout: {
      "icon-image": "tlt7",
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  chsmeo_cams_Point_s: {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "status"]],
        "work",
        "cameraWork",
        "error",
        "cameraError",
        "inactive",
        "cameraInactive",
        "camera"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "8560fe75-49b2-432a-8494-eab530c8fc4e_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": "cameraWork",
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "db258075-aaf2-43c3-85da-065834afada3_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": "cameraWork",
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  chsmeo_ngpt_Point_s: {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "type"]],
        "1",
        "trolleybus",
        "2",
        "busGreen",
        "3",
        "tram",
        "4",
        "mtaxi",
        "bus"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  events_Point_s: {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "event_class_id"]],
        "ДТП",
        "roadAccident",
        "Ремонтные работы",
        "roadWork",
        "Мероприятия",
        "roadEvent",
        "roadEvent"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "f07ce2e2-253a-4ed7-9529-463b1b2ff1ad_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "Статус"]],
        "0",
        "rgba(255, 62, 62, 0.1)",
        "1",
        "rgba(89, 214, 78, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "Статус"]],
        "0",
        "rgba(255, 62, 62, 1)",
        "1",
        "rgba(89, 214, 78, 1)",
        "rgba(255, 62, 62, 1)"
      ],
      "circle-stroke-width": 1
    }
  },
  "f07ce2e2-253a-4ed7-9529-463b1b2ff1ad_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "Статус"]],
        "0",
        "cameraError",
        "1",
        "cameraWork",
        "cameraError"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "TagilPublicTransport?format=vehicles_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "code"]],
        "299",
        "rgba(89, 214, 78, 0.1)",
        "300",
        "rgba(255, 172, 0, 0.1)",
        "rgba(89, 214, 78, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "code"]],
        "299",
        "rgb(89, 214, 78)",
        "300",
        "rgb(255, 172, 0)",
        "rgb(89, 214, 78)"
      ],
      "circle-stroke-width": 1
    }
  },
  "TagilPublicTransport?format=vehicles_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "code"]],
        "299",
        "busGreen",
        "300",
        "tram",
        "busGreen"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  chsmeo_cams_kps_Point: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "status"]],
        "work",
        "rgba(89, 214, 78, 0.1)",
        "error",
        "rgba(255, 62, 62, 0.1)",
        "inactive",
        "rgba(119, 119, 119, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "status"]],
        "work",
        "rgb(89, 214, 78)",
        "error",
        "rgb(255, 62, 62)",
        "inactive",
        "rgb(119, 119, 119)",
        "rgb(255, 62, 62)"
      ],
      "circle-stroke-width": 1
    }
  },
  chsmeo_cams_kps_Point_s: {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "status"]],
        "work",
        "cameraWork",
        "error",
        "cameraError",
        "inactive",
        "cameraInactive",
        "camera"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  TagilDetector_Point: {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "is_active"]],
        "true",
        "rgba(89, 214, 78, 0.1)",
        "false",
        "rgba(255, 62, 62, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "is_active"]],
        "true",
        "rgb(89, 214, 78)",
        "false",
        "rgb(255, 62, 62)",
        "rgb(255, 62, 62)"
      ],
      "circle-stroke-width": 1
    }
  },
  TagilDetector_Point_s: {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "is_active"]],
        "true",
        "cameraWork",
        "false",
        "cameraError",
        "camera"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "TagilPublicTransport?format=stops_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": "busBlue",
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "TagilPublicTransport?format=stops_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": "rgba(46, 147, 254, 0.1)",
      "circle-pitch-alignment": "map",
      "circle-stroke-color": "#2e93fe",
      "circle-stroke-width": 1
    }
  },
  "TagilPublicTransport?format=dit_Point_s": {
    type: "symbol",
    layout: {
      "icon-image": [
        "match",
        ["to-string", ["get", "is_active"]],
        "true",
        "busGreen",
        "false",
        "busError",
        "busError"
      ],
      "icon-size": {
        base: 1.8,
        stops: [[12, 0.1], [18, 1]]
      }
    }
  },
  "TagilPublicTransport?format=dit_Point": {
    type: "circle",
    layout: {},
    paint: {
      "circle-radius": {
        base: 1.75,
        stops: [[12, 8], [18, 80]]
      },
      "circle-color": [
        "match",
        ["to-string", ["get", "is_active"]],
        "true",
        "rgba(89, 214, 78, 0.1)",
        "false",
        "rgba(255, 62, 62, 0.1)",
        "rgba(255, 62, 62, 0.1)"
      ],
      "circle-pitch-alignment": "map",
      "circle-stroke-color": [
        "match",
        ["to-string", ["get", "is_active"]],
        "true",
        "rgb(89, 214, 78)",
        "false",
        "rgb(255, 62, 62)",
        "rgb(255, 62, 62)"
      ],
      "circle-stroke-width": 1
    }
  }
};
